import { donationsByUserId } from '@/entities/donations'
import {
  type DeleteApiDonationsByUserIdDonationsDonationidPathParams,
  type UserDonationListModel,
} from '@/shared/api'
import { TableWrapper } from '@/shared/ui'
import { Table, type TableProps } from 'antd'
import { useUnit } from 'effector-react'

import { useDonationsByUserIdTableColumns } from './useDonationsByUserIdTableColumns'

interface DonationsByUserIdTableProps {
  userId: string
  onDelete: (
    id: DeleteApiDonationsByUserIdDonationsDonationidPathParams['Id'],
    donationId: DeleteApiDonationsByUserIdDonationsDonationidPathParams['DonationId'],
  ) => void
}
export const DonationsByUserIdTable = ({
  userId,
  onDelete: handleDelete,
}: DonationsByUserIdTableProps) => {
  const { data, pending } = useUnit(donationsByUserId)

  const tableColumns: TableProps<UserDonationListModel>['columns'] =
    useDonationsByUserIdTableColumns({ userId, handleDelete })

  if (!data?.donations || !data.donations.length) {
    return null
  }

  return (
    <TableWrapper>
      <Table
        sticky
        showSorterTooltip={false}
        rowKey={(record) => `${record.id}_${record.date}`}
        bordered
        columns={tableColumns}
        dataSource={data.donations}
        loading={pending}
        pagination={false}
      />
    </TableWrapper>
  )
}
